var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info-bar-wrapper",class:{ error: _vm.error, hidden: _vm.hidden }},[_c('div',{staticClass:"msg"},[_vm._v(_vm._s(_vm.message))]),_c('div',{staticClass:"clear",on:{"click":_vm.close}}),_c('div',{staticClass:"one",on:{"click":_vm.close}},[_c('div',{staticClass:"two",on:{"click":_vm.close}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }